(function () {
  'use strict';

  /*
    SFG EFILive Error Database
    --------------------------
    Used by sfg-support-codes.js

    Official EFILive reference:
    https://content.efilive.com/documents/EFILive%20Error%20Codes.pdf

    SFG EFI Live instructions:
    https://sfgtunes.com/pages/efi-live-instructions

    EFILive support:
    https://service.efilive.com/new-ticket
  */

  var GUIDE =
    'https://content.efilive.com/documents/EFILive%20Error%20Codes.pdf';

  var SFG_HELP =
    'https://sfgtunes.com/pages/efi-live-instructions';

  var EFI_SUPPORT =
    'https://service.efilive.com/new-ticket';

  function R(title, category, customerText, action, extra) {
    var out = {
      title: title,
      category: category,
      customerText: customerText,
      action: action,
      guide: GUIDE
    };

    Object.keys(extra || {}).forEach(function (key) {
      out[key] = extra[key];
    });

    return out;
  }

  var X = {};

  /*
    ------------------------------------------------------------
    USB DRIVER / HAPI
    ------------------------------------------------------------
  */

  X['$0002'] = R(
    'EFILive device not connected to computer',
    'usb_connection',
    'FlashScan or AutoCal is not being detected through USB. Check the USB cable and connection to the computer.',
    'check_usb',
    {
      link: EFI_SUPPORT,
      linkLabel: 'EFILive Support',
      vendorSupport: true
    }
  );

  X['$0013'] = R(
    'Too many USB hubs',
    'usb_connection',
    'The EFILive device is connected through too many USB hubs. Connect FlashScan or AutoCal directly to the computer if possible.',
    'direct_usb'
  );

  X['$0022'] = R(
    'EFILive USB request timed out',
    'pc_software',
    'Another program may be using the EFILive device. Close other EFILive programs or applications that may be communicating with FlashScan or AutoCal, then retry.',
    'close_other_software'
  );

  X['$0024'] = R(
    'EFILive HAPI is not running',
    'pc_software',
    'The EFILive HAPI service could not be started. Repair or reinstall the current EFILive V8 software, then retry.',
    'reinstall_v8',
    {
      link: SFG_HELP,
      linkLabel: 'EFI Live Instructions'
    }
  );

  X['$0025'] = R(
    'EFILive device is busy with another application',
    'pc_software',
    'More than one application is trying to communicate with the EFILive device. Allow the other operation to finish, close unnecessary EFILive applications and retry.',
    'close_other_software'
  );

  X['$002F'] = R(
    'EFILive device not connected by USB',
    'usb_connection',
    'FlashScan or AutoCal is not communicating with the computer. Check the USB cable and try a direct USB connection.',
    'check_usb'
  );

  X['$0030'] = R(
    'EFILive software component versions do not match',
    'pc_software',
    'The installed EFILive V8 application and HAPI components do not match. Reinstall the latest EFILive V8 software.',
    'reinstall_v8',
    {
      link: SFG_HELP,
      linkLabel: 'EFI Live Instructions'
    }
  );

  ['$0031', '$0032', '$0033', '$0034'].forEach(function (code) {
    X[code] = R(
      'EFILive HAPI installation problem',
      'pc_software',
      'EFILive HAPI cannot be located, started or accessed correctly. Repair or reinstall the current EFILive V8 software.',
      'reinstall_v8',
      {
        link: SFG_HELP,
        linkLabel: 'EFI Live Instructions'
      }
    );
  });

  X['$0035'] = R(
    'Another EFILive operation is already active',
    'pc_software',
    'Stop other reading, flashing or scanning activity and retry the operation.',
    'close_other_software'
  );

  X['$0036'] = R(
    'Device does not have the required tuning license',
    'licensing',
    'The connected EFILive device does not support the requested tuning/programming operation with its current license.',
    'vendor_support',
    {
      link: EFI_SUPPORT,
      linkLabel: 'EFILive Support',
      vendorSupport: true
    }
  );

  /*
    ------------------------------------------------------------
    DEVICE FIRMWARE / BOOT
    ------------------------------------------------------------
  */

  X['$0081'] = R(
    'EFILive device RAM failure',
    'device_hardware',
    'The EFILive device has detected an internal memory hardware failure. This requires EFILive support.',
    'vendor_support',
    {
      link: EFI_SUPPORT,
      linkLabel: 'EFILive Support',
      vendorSupport: true
    }
  );

  X['$0084'] = R(
    'EFILive boot block CRC failure',
    'device_firmware',
    'The device has detected a problem with its boot software. Contact EFILive for recovery or repair guidance.',
    'vendor_support',
    {
      link: EFI_SUPPORT,
      linkLabel: 'EFILive Support',
      vendorSupport: true
    }
  );

  ['$0085', '$0086', '$0087', '$0088'].forEach(function (code) {
    X[code] = R(
      'EFILive device firmware is missing or corrupt',
      'device_firmware',
      'The FlashScan or AutoCal firmware appears to be missing or corrupt. The device may require firmware recovery or dead-poll recovery.',
      'firmware_recovery',
      {
        link: EFI_SUPPORT,
        linkLabel: 'EFILive Support',
        vendorSupport: true
      }
    );
  });

  X['$0090'] = R(
    'Firmware and boot block are incompatible',
    'device_firmware',
    'The firmware installed on the device does not match the boot block. Update the device using the current EFILive V8 software.',
    'update_firmware',
    {
      link: SFG_HELP,
      linkLabel: 'EFI Live Instructions'
    }
  );

  X['$0091'] = R(
    'EFILive device did not reboot after firmware update',
    'device_firmware',
    'The device did not restart normally after a firmware update. If it does not recover normally, contact EFILive Support.',
    'vendor_support',
    {
      link: EFI_SUPPORT,
      linkLabel: 'EFILive Support',
      vendorSupport: true
    }
  );

  /*
    ------------------------------------------------------------
    USB COMMUNICATION
    ------------------------------------------------------------
  */

  X['$0100'] = R(
    'No USB connection',
    'usb_connection',
    'Check the USB cable, plugs and connections. Try a different USB port and, if available, a known-good USB cable.',
    'check_usb'
  );

  X['$0101'] = R(
    'No USB data received',
    'usb_connection',
    'The computer and EFILive device are not exchanging data correctly. Try a known-good cable, another USB port and restarting the computer.',
    'check_usb',
    {
      link: EFI_SUPPORT,
      linkLabel: 'EFILive Support',
      vendorSupportIfPersistent: true
    }
  );

  ['$0109', '$010A'].forEach(function (code) {
    X[code] = R(
      'EFILive device firmware is out of date',
      'device_firmware',
      'The device firmware does not understand the command being sent by the current software. Update the device firmware using the current EFILive V8 software.',
      'update_firmware',
      {
        link: SFG_HELP,
        linkLabel: 'EFI Live Instructions'
      }
    );
  });

  X['$010B'] = R(
    'EFILive device is PIN locked',
    'device_security',
    'The FlashScan device has been locked with a user PIN. Enter the correct PIN. If the PIN is unavailable, contact EFILive.',
    'vendor_support',
    {
      link: EFI_SUPPORT,
      linkLabel: 'EFILive Support',
      vendorSupport: true
    }
  );

  X['$010C'] = R(
    'EFILive device is busy',
    'device_busy',
    'The device is already being used for another pass-through, logging, reading or flashing operation. Exit the active operation and retry.',
    'exit_active_operation'
  );

  X['$010D'] = R(
    'AutoCal is not linked',
    'device_linking',
    'The AutoCal has not been linked to its parent FlashScan device. Review the AutoCal linking instructions before continuing.',
    'check_autocal_link',
    {
      link: SFG_HELP,
      linkLabel: 'EFI Live Instructions'
    }
  );

  /*
    ------------------------------------------------------------
    FILE SYSTEM / DEVICE STORAGE
    ------------------------------------------------------------
  */

  X['$0182'] = R(
    'EFILive device file system is not formatted',
    'device_storage',
    'The required CONFIG or DATA file system is not formatted. Follow the EFILive device setup instructions to format the appropriate file system.',
    'format_filesystem',
    {
      link: SFG_HELP,
      linkLabel: 'EFI Live Instructions'
    }
  );

  X['$0185'] = R(
    'Required file or folder is missing',
    'device_storage',
    'A required file or folder cannot be found on the EFILive device. The device configuration or required files may need to be programmed again.',
    'reprogram_bbx',
    {
      bbxRelated: true,
      link: SFG_HELP,
      linkLabel: 'EFI Live Instructions'
    }
  );

  X['$0190'] = R(
    'SD card was removed',
    'device_storage',
    'The SD card is not present. Reinsert it securely before retrying.',
    'check_sd_card'
  );

  X['$0194'] = R(
    'Unable to write to EFILive device storage',
    'device_storage',
    'The device storage may be full or the BBX configuration may need to be reprogrammed. Check available storage and review the BBX setup.',
    'check_storage_bbx',
    {
      bbxRelated: true,
      link: SFG_HELP,
      linkLabel: 'EFI Live Instructions'
    }
  );

  X['$0197'] = R(
    'SD card is write protected',
    'device_storage',
    'The SD card is write protected. Unlock the card before retrying.',
    'unlock_sd_card'
  );

  X['$01C3'] = R(
    'AutoCal / FlashScan V3 storage is in USB drive mode',
    'device_storage',
    'The device storage is currently exposed to Windows as a USB drive. Disable the USB thumb-drive mode before retrying the EFILive operation.',
    'disable_usb_drive_mode'
  );

  X['$01CB'] = R(
    'EFILive V3 file system is not formatted',
    'device_storage',
    'The device file system is not formatted. Format the appropriate DATA file system before continuing.',
    'format_filesystem'
  );

  X['$01CC'] = R(
    'No free space on EFILive device',
    'device_storage',
    'The EFILive device does not have enough free storage. Delete unnecessary files and retry.',
    'free_storage'
  );

  X['$01CD'] = R(
    'Required file was not found',
    'device_storage',
    'A required file or folder is missing from the device. Recheck the device configuration and files.',
    'reprogram_bbx',
    {
      bbxRelated: true,
      link: SFG_HELP,
      linkLabel: 'EFI Live Instructions'
    }
  );

  /*
    ------------------------------------------------------------
    OBD / VEHICLE COMMUNICATION
    ------------------------------------------------------------
  */

  X['$0280'] = R(
    'Vehicle communication protocol not detected',
    'vehicle_communication',
    'EFILive cannot detect a valid vehicle communication protocol. Confirm the ignition is ON, not ACC, and check the OBD/device connections.',
    'check_vehicle_power_communication',
    {
      ticketRecommendedIfPersistent: true
    }
  );

  X['$0281'] = R(
    'No data received from vehicle',
    'vehicle_communication',
    'The EFILive device is not receiving valid data from the vehicle. Confirm ignition is ON and check OBD power, cables and vehicle communication.',
    'check_vehicle_power_communication',
    {
      ticketRecommendedIfPersistent: true
    }
  );

  X['$028D'] = R(
    'PID configuration mismatch',
    'logging_configuration',
    'A selected PID does not match the controller configuration. Remove the offending PID and contact EFILive if the problem persists.',
    'vendor_support',
    {
      link: EFI_SUPPORT,
      linkLabel: 'EFILive Support',
      vendorSupportIfPersistent: true
    }
  );

  X['$028E'] = R(
    'Too many DMA PIDs selected',
    'logging_configuration',
    'Too many DMA PIDs are selected for logging. Reduce the DMA PID count before retrying.',
    'reduce_pids'
  );

  X['$0290'] = R(
    'J1939 protocol is not supported by this device',
    'device_compatibility',
    'This operation requires a heavy-duty J1939-capable EFILive device.',
    'check_device_compatibility',
    {
      ticketRecommended: true
    }
  );

  X['$0291'] = R(
    'J1979 protocol is not supported by this device',
    'device_compatibility',
    'This operation requires a compatible light/medium-duty EFILive device.',
    'check_device_compatibility',
    {
      ticketRecommended: true
    }
  );

  X['$0299'] = R(
    'Too many PIDs selected',
    'logging_configuration',
    'Too many scan parameters have been selected. Reduce the PID count and retry.',
    'reduce_pids'
  );

  X['$029A'] = R(
    'Device is still in pass-through mode',
    'device_busy',
    'Complete or exit pass-through operations before attempting the stand-alone operation.',
    'exit_pass_through'
  );

  X['$029B'] = R(
    'Data logging stalled',
    'logging_configuration',
    'The selected PID configuration may contain unsupported parameters. Verify that the correct controller and PIDs are selected.',
    'check_logging_configuration'
  );

  /*
    ------------------------------------------------------------
    CONTROLLER COMMUNICATION / SECURITY
    ------------------------------------------------------------
  */

  X['$0301'] = R(
    'Controller data transfer incomplete',
    'controller_communication',
    'The controller did not receive the complete data transfer. Communication quality or transfer speed may be involved.',
    'check_vehicle_network',
    {
      ticketRecommendedIfPersistent: true
    }
  );

  X['$0311'] = R(
    'Requested controller mode is not supported',
    'controller_communication',
    'The controller does not support the requested operation or mode. If this occurs during BBX operation, the BBX configuration should also be checked.',
    'check_bbx_or_controller',
    {
      bbxRelated: true,
      link: SFG_HELP,
      linkLabel: 'EFI Live Instructions'
    }
  );

  X['$0321'] = R(
    'Controller is busy',
    'controller_communication',
    'The controller was temporarily unable to process the request. Retry once. If the error continues, create a support ticket.',
    'retry_then_ticket',
    {
      ticketRecommendedIfPersistent: true
    }
  );

  X['$0322'] = R(
    'Controller conditions or request sequence not correct',
    'controller_security',
    'The controller was not ready for the requested operation. On some newer GM controllers this can also indicate an authorization/security-key issue.',
    'ticket',
    {
      ticketRecommended: true
    }
  );

  X['$0333'] = R(
    'Controller security access denied',
    'controller_security',
    'The controller could not be unlocked. On supported Cummins vehicles this may also indicate a Security Gateway bypass problem.',
    'check_security_then_ticket',
    {
      ticketRecommended: true
    }
  );

  X['$0335'] = R(
    'Incorrect controller unlock key',
    'controller_security',
    'The controller appears to be locked with a custom key or the supplied key is incorrect. Create a support ticket before making further programming attempts.',
    'ticket',
    {
      ticketRecommended: true
    }
  );

  X['$0336'] = R(
    'Too many controller unlock attempts',
    'controller_security',
    'The controller has rejected too many unlock attempts. Follow the normal ignition-cycle procedure and retry only after the controller has reset.',
    'ignition_cycle'
  );

  X['$0337'] = R(
    'Controller not ready for unlock',
    'controller_security',
    'The controller cannot be unlocked immediately after ignition-on. Wait at least 10 seconds after turning the ignition ON before retrying.',
    'wait_and_retry'
  );

  X['$0340'] = R(
    'Controller rejected programming download',
    'programming_failure',
    'The controller rejected the programming download. Stop further experimentation and create an SFG support ticket with the exact error and vehicle information.',
    'ticket',
    {
      ticketRecommended: true,
      programmingFailure: true
    }
  );

  X['$0373'] = R(
    'Programming data transfer interrupted',
    'vehicle_network',
    'The programming data sequence was interrupted. Vehicle network communication may have been disturbed by another module or device.',
    'check_vehicle_network',
    {
      ticketRecommendedIfPersistent: true
    }
  );

  X['$0385'] = R(
    'General controller programming failure',
    'programming_failure',
    'Programming was aborted. Battery voltage, vehicle communication or the controller itself may be involved. Create a support ticket before making further recovery attempts.',
    'ticket',
    {
      ticketRecommended: true,
      programmingFailure: true,
      programmingRecovery: true
    }
  );

  X['$03A0'] = R(
    'ECU is not responding',
    'vehicle_communication',
    'The controller is not responding to EFILive. Check ignition position, OBD power and vehicle network communication. If this followed a failed write, stop and create a recovery ticket.',
    'check_communication_or_recovery',
    {
      ticketRecommended: true
    }
  );

  X['$03FE'] = R(
    'Final flash checksum failed',
    'programming_failure',
    'The final programming checksum did not verify correctly. Create an SFG support ticket with the exact error and do not continue experimenting with files.',
    'ticket',
    {
      ticketRecommended: true,
      programmingFailure: true
    }
  );

  /*
    ------------------------------------------------------------
    SD CARD
    ------------------------------------------------------------
  */

  X['$0402'] = R(
    'SD card not present',
    'device_storage',
    'Insert the SD card fully before retrying.',
    'check_sd_card'
  );

  X['$0405'] = R(
    'SD card is write protected',
    'device_storage',
    'Unlock the SD card write-protect switch before retrying.',
    'unlock_sd_card'
  );

  ['$0406', '$0407', '$0408', '$040C', '$040E', '$040F',
   '$0410', '$0411', '$0412', '$0413', '$0414', '$0415',
   '$0416', '$0418'].forEach(function (code) {
    X[code] = R(
      'SD card error',
      'device_storage',
      'EFILive has detected an SD card read/write or communication fault. Try a known-good compatible SD card.',
      'replace_sd_card'
    );
  });

  /*
    ------------------------------------------------------------
    BLACK BOX / BBX
    ------------------------------------------------------------
  */

  ['$0481', '$0482', '$0483'].forEach(function (code) {
    X[code] = R(
      'BBX configuration file problem',
      'bbx_configuration',
      'The Black Box configuration files are missing, corrupt or incompatible with the current software/firmware. Update EFILive V8 and firmware, then program the BBX configuration again.',
      'reprogram_bbx',
      {
        bbxRelated: true,
        link: SFG_HELP,
        linkLabel: 'EFI Live Instructions'
      }
    );
  });

  /*
    ------------------------------------------------------------
    READING / FLASHING
    ------------------------------------------------------------
  */

  X['$0508'] = R(
    'Read or flash operation was cancelled',
    'read_flash',
    'The read/flash script was interrupted before completion. Restart the operation only if no controller programming failure occurred.',
    'retry_if_safe'
  );

  X['$050A'] = R(
    'Not enough space to save tune file',
    'device_storage',
    'The AutoCal or FlashScan does not have enough free storage to save the read file. Delete unnecessary files and retry.',
    'free_storage'
  );

  X['$050B'] = R(
    'BBX script requires newer firmware',
    'bbx_configuration',
    'The device firmware does not support the installed BBX script. Update EFILive V8 and device firmware, then program the BBX configuration again.',
    'update_and_reprogram_bbx',
    {
      bbxRelated: true,
      link: SFG_HELP,
      linkLabel: 'EFI Live Instructions'
    }
  );

  X['$050C'] = R(
    'Requested read/flash operation is not available',
    'bbx_configuration',
    'The selected controller operation is not available or the required BBX script is missing. Verify the BBX controller configuration.',
    'reprogram_bbx',
    {
      bbxRelated: true,
      link: SFG_HELP,
      linkLabel: 'EFI Live Instructions'
    }
  );

  X['$050D'] = R(
    'Controller not supported',
    'controller_compatibility',
    'EFILive does not recognize this controller for the requested operation. Create an SFG ticket with the controller and exact error.',
    'ticket',
    {
      ticketRecommended: true
    }
  );

  X['$0520'] = R(
    'Tune file cannot be opened',
    'tune_file',
    'The requested tune file cannot be found or opened on the EFILive device. Copy the tune file to the device again and verify the device storage.',
    'recopy_tune_file'
  );

  X['$0521'] = R(
    'Tune file cannot be read',
    'tune_file',
    'The tune file may be corrupt. Copy a fresh copy of the file to the AutoCal or FlashScan.',
    'recopy_tune_file'
  );

  X['$0522'] = R(
    'Tune file CRC is incorrect',
    'tune_file',
    'The tune file appears to have been corrupted. Copy a fresh copy of the file to the device. If the replacement file produces the same error, create an SFG ticket.',
    'recopy_then_ticket',
    {
      ticketRecommendedIfPersistent: true
    }
  );

  ['$0523', '$0524'].forEach(function (code) {
    X[code] = R(
      'Tune file is incomplete or corrupt',
      'tune_file',
      'EFILive cannot correctly verify the contents of the tune file. Copy a fresh copy of the file to the device. If the problem remains, create an SFG ticket.',
      'recopy_then_ticket',
      {
        ticketRecommendedIfPersistent: true
      }
    );
  });

  ['$0525', '$0526'].forEach(function (code) {
    X[code] = R(
      'Tune file is not compatible with current EFILive software/firmware',
      'tune_file',
      'Update EFILive V8 and the AutoCal/FlashScan firmware. If both are current and this error remains, create an SFG ticket.',
      'update_then_ticket',
      {
        ticketRecommendedIfPersistent: true,
        link: SFG_HELP,
        linkLabel: 'EFI Live Instructions'
      }
    );
  });

  X['$0527'] = R(
    'Tune file contains a controller checksum problem',
    'tune_file',
    'EFILive has detected a checksum problem in the tune file. Do not attempt to correct or modify the file yourself. Create an SFG support ticket.',
    'ticket',
    {
      ticketRecommended: true,
      status: 'READY FOR SFG REVIEW'
    }
  );

  /*
    ------------------------------------------------------------
    LICENSING / AUTOCAL SECURITY
    ------------------------------------------------------------
  */

  X['$0530'] = R(
    'Tune file is restricted to a different EFILive device',
    'tune_file_security',
    'The tune file is authorized for a different FlashScan or AutoCal. Create an SFG support ticket so the file/device assignment can be reviewed.',
    'ticket',
    {
      ticketRecommended: true
    }
  );

  X['$0531'] = R(
    'Tune file is restricted to a different controller',
    'tune_file_security',
    'The tune file is locked to a different controller serial number. Create an SFG support ticket before attempting further programming.',
    'ticket',
    {
      ticketRecommended: true
    }
  );

  X['$0532'] = R(
    'Controller is not licensed',
    'licensing',
    'The controller has not yet been licensed by the EFILive device. Complete the VIN licensing process before flashing.',
    'license_controller',
    {
      link: SFG_HELP,
      linkLabel: 'EFI Live Instructions'
    }
  );

  X['$0533'] = R(
    'No VIN license slots available',
    'licensing',
    'The EFILive device does not have an unused VIN license available. Create an SFG support ticket if you need help obtaining or applying the correct license.',
    'ticket',
    {
      ticketRecommended: true
    }
  );

  X['$0534'] = R(
    'Controller serial number is invalid',
    'controller_identity',
    'EFILive received an invalid controller serial number. Retry once. If the same error returns, create a support ticket.',
    'retry_then_ticket',
    {
      ticketRecommendedIfPersistent: true
    }
  );

  X['$0535'] = R(
    'AutoCal is not linked to its tuner',
    'device_linking',
    'The AutoCal is not linked to the required FlashScan/tuner. Review the AutoCal linking instructions.',
    'check_autocal_link',
    {
      link: SFG_HELP,
      linkLabel: 'EFI Live Instructions'
    }
  );

  X['$0536'] = R(
    'Tune file is not registered to this AutoCal',
    'tune_file_security',
    'This tune file was not created for the connected AutoCal. Create an SFG support ticket so the file can be checked.',
    'ticket',
    {
      ticketRecommended: true
    }
  );

  X['$0537'] = R(
    'Controller is locked with a custom key',
    'controller_security',
    'The controller cannot be unlocked using the normal key. Create an SFG support ticket before continuing.',
    'ticket',
    {
      ticketRecommended: true
    }
  );

  X['$0538'] = R(
    'DSP operating system cannot be read',
    'controller_read',
    'A controller running a DSP custom operating system cannot be read normally. This does not necessarily indicate a fault.',
    'informational',
    {
      ticketRecommended: false
    }
  );

  X['$0539'] = R(
    'Tune file does not permit a full flash',
    'tune_file_security',
    'The tune file has been configured to prevent full flashing. Create an SFG ticket if a full flash is required.',
    'ticket',
    {
      ticketRecommended: true
    }
  );

  X['$0540'] = R(
    'Tune file operating system is incompatible',
    'tune_file',
    'The operating system in the tune file is not compatible with the target controller. Do not continue trying different flash options. Create an SFG ticket.',
    'ticket',
    {
      ticketRecommended: true
    }
  );

  X['$0541'] = R(
    'Unknown controller NVRAM structure',
    'controller_internal',
    'EFILive does not recognize the controller NVRAM structure. Create an SFG ticket and include this exact error.',
    'ticket',
    {
      ticketRecommended: true
    }
  );

  X['$0542'] = R(
    'Tune file is missing required operating-system data',
    'tune_file',
    'The tune file requires additional operating-system data before a full flash can be performed. Create an SFG ticket so the file can be checked.',
    'ticket',
    {
      ticketRecommended: true
    }
  );

  X['$0543'] = R(
    'Controller could not be erased',
    'programming_failure',
    'EFILive was unable to erase the controller for programming. Stop further attempts and create an SFG support ticket.',
    'ticket',
    {
      ticketRecommended: true,
      programmingFailure: true,
      programmingRecovery: true
    }
  );

  X['$0544'] = R(
    'Controller serial number was not retrieved correctly',
    'controller_identity',
    'EFILive received an invalid serial number from the controller. Retry the identification/licensing operation. If it continues, create a support ticket.',
    'retry_then_ticket',
    {
      ticketRecommendedIfPersistent: true
    }
  );

  X['$0548'] = R(
    'Flash checksum failed',
    'programming_failure',
    'The programmed data did not verify correctly. Stop further experimentation and create an SFG support ticket.',
    'ticket',
    {
      ticketRecommended: true,
      programmingFailure: true,
      programmingRecovery: true
    }
  );

  X['$0549'] = R(
    'Ignition off or controller failed to return after flashing',
    'programming_communication',
    'First confirm the ignition is ON, not ACC. If this appeared after a flash completed or the controller no longer communicates normally, create an SFG recovery ticket.',
    'check_ignition_or_recovery',
    {
      ticketRecommended: true,
      programmingRecoveryPossible: true
    }
  );

  X['$054A'] = R(
    'Boot loader could not start',
    'vehicle_network',
    'Vehicle network interference can prevent the controller boot loader from starting. Disconnect aftermarket OBD/CAN equipment and check for other network interference. If the error remains, create an SFG ticket.',
    'isolate_network_then_ticket',
    {
      ticketRecommendedIfPersistent: true
    }
  );

  X['$054B'] = R(
    'Recovery file cannot use Auto-Lock',
    'programming_recovery',
    'A previous full flash failed and the selected file cannot be used for recovery. Do not remove controller power or continue experimenting. Create an SFG recovery ticket.',
    'ticket',
    {
      ticketRecommended: true,
      programmingFailure: true,
      programmingRecovery: true
    }
  );

  X['$054C'] = R(
    'Operating system is missing from tune file',
    'tune_file',
    'The file does not contain the operating system required for a full flash. Create an SFG ticket if a full flash is required.',
    'ticket',
    {
      ticketRecommended: true
    }
  );

  X['$054D'] = R(
    'Full flash is required before calibration-only flashing',
    'flash_type',
    'This file requires an initial full flash before calibration-only flashing can be used. Follow the supplied SFG flashing instructions.',
    'full_flash_required',
    {
      link: SFG_HELP,
      linkLabel: 'EFI Live Instructions'
    }
  );

  X['$054E'] = R(
    'Controller does not support calibration-only flashing for this operation',
    'flash_type',
    'The selected controller/file requires a full flash for this operation.',
    'full_flash_required',
    {
      link: SFG_HELP,
      linkLabel: 'EFI Live Instructions'
    }
  );

  ['$0550', '$0551'].forEach(function (code) {
    X[code] = R(
      'Controller authorization file problem',
      'controller_authorization',
      'The controller authorization file could not be created or read correctly. Verify current software/firmware and device configuration. If the error remains, create an SFG ticket.',
      'update_then_ticket',
      {
        ticketRecommendedIfPersistent: true
      }
    );
  });

  X['$0552'] = R(
    'Controller has not yet been authorized',
    'controller_authorization',
    'This controller requires authorization before reading or flashing. Create an SFG support ticket if authorization has not already been arranged.',
    'ticket',
    {
      ticketRecommended: true
    }
  );

  /*
    ------------------------------------------------------------
    LOWER-LEVEL FLASH FAILURES
    ------------------------------------------------------------
  */

  X['$0688'] = R(
    'Controller programming-voltage failure',
    'controller_hardware',
    'The controller reported an internal programming-voltage fault. Create an SFG support ticket before further programming attempts.',
    'ticket',
    {
      ticketRecommended: true,
      programmingFailure: true
    }
  );

  X['$0689'] = R(
    'Unknown controller flash memory',
    'controller_hardware',
    'The controller contains an unexpected or unsupported flash-memory device. Create a support ticket.',
    'ticket',
    {
      ticketRecommended: true
    }
  );

  X['$06FF'] = R(
    'Controller flash checksum failure',
    'programming_failure',
    'The data written to the controller did not pass checksum verification. Stop further attempts and create an SFG support ticket.',
    'ticket',
    {
      ticketRecommended: true,
      programmingFailure: true,
      programmingRecovery: true
    }
  );

  /*
    ------------------------------------------------------------
    SCANNING
    ------------------------------------------------------------
  */

  X['$0701'] = R(
    'EDA scanning is not supported by this controller',
    'logging_configuration',
    'The selected EDA logging mode is not supported by the current controller configuration.',
    'check_logging_configuration'
  );

  X['$0702'] = R(
    'Data logging memory limit reached',
    'logging_configuration',
    'EFILive stopped logging because the configured logging memory limit was reached.',
    'adjust_logging_limit'
  );

  /*
    ------------------------------------------------------------
    BBX CONFIGURATION
    ------------------------------------------------------------
  */

  ['$0A01', '$0A02'].forEach(function (code) {
    X[code] = R(
      'BBX configuration is missing or damaged',
      'bbx_configuration',
      'The AutoCal/FlashScan Black Box configuration is not programmed correctly. Program the BBX configuration again using EFILive V8.',
      'reprogram_bbx',
      {
        bbxRelated: true,
        link: SFG_HELP,
        linkLabel: 'EFI Live Instructions'
      }
    );
  });

  X['$0A03'] = R(
    'No controller configured for data logging',
    'bbx_configuration',
    'The device BBX configuration does not contain a controller configured for logging. Program the correct BBX setup.',
    'reprogram_bbx',
    {
      bbxRelated: true,
      link: SFG_HELP,
      linkLabel: 'EFI Live Instructions'
    }
  );

  X['$0A04'] = R(
    'No PIDs configured for selected controller',
    'bbx_configuration',
    'The BBX configuration does not contain logging PIDs for the selected controller.',
    'reprogram_bbx',
    {
      bbxRelated: true,
      link: SFG_HELP,
      linkLabel: 'EFI Live Instructions'
    }
  );

  X['$0A05'] = R(
    'No controller configured for reading',
    'bbx_configuration',
    'The AutoCal/FlashScan BBX configuration does not contain the required controller read setup. Program the BBX configuration again.',
    'reprogram_bbx',
    {
      bbxRelated: true,
      link: SFG_HELP,
      linkLabel: 'EFI Live Instructions'
    }
  );

  ['$0A06', '$0A07'].forEach(function (code) {
    X[code] = R(
      'Required BBX file is missing',
      'bbx_configuration',
      'The configured menu references a tune, controller or BBX file that is not present on the device. Reprogram the device configuration.',
      'reprogram_bbx',
      {
        bbxRelated: true,
        link: SFG_HELP,
        linkLabel: 'EFI Live Instructions'
      }
    );
  });

  X['$0A11'] = R(
    'VIN-license import file is invalid',
    'licensing',
    'The VIN-license import file is not valid. A new export file is required.',
    'license_file_problem'
  );

  X['$0A12'] = R(
    'VIN-license file belongs to another device',
    'licensing',
    'The license import file is not licensed to this EFILive device. Contact EFILive for device-license assistance.',
    'vendor_support',
    {
      link: EFI_SUPPORT,
      linkLabel: 'EFILive Support',
      vendorSupport: true
    }
  );

  X['$0A13'] = R(
    'Not enough VIN-license slots for import',
    'licensing',
    'The device does not have enough unused VIN-license slots for the requested import.',
    'license_capacity'
  );

  X['$0A14'] = R(
    'No VIN licenses were imported',
    'licensing',
    'The import did not contain any used VIN licenses that were eligible to be added to this device.',
    'license_import'
  );

  X['$0A21'] = R(
    'Switchable tuning is not supported by selected controller',
    'switching',
    'The selected controller/operating system does not support the requested switchable-tune function.',
    'ticket',
    {
      ticketRecommended: true
    }
  );

  X['$0A22'] = R(
    'Switch names are not configured',
    'bbx_configuration',
    'Switchable tune names are missing from the BBX configuration.',
    'reprogram_bbx',
    {
      bbxRelated: true,
      link: SFG_HELP,
      linkLabel: 'EFI Live Instructions'
    }
  );

  X['$0A23'] = R(
    'Selected switch position is out of range',
    'bbx_configuration',
    'The BBX switching configuration contains more tune positions than the selected operating system supports.',
    'check_switch_configuration',
    {
      bbxRelated: true
    }
  );

  X['$0A24'] = R(
    'Selected switchable tune type is not supported',
    'switching',
    'The requested DSP/CSP switching mode does not match the operating system installed in the controller.',
    'ticket',
    {
      ticketRecommended: true
    }
  );

  /*
    ------------------------------------------------------------
    FAMILY FALLBACKS

    Exact codes above always win.
    These ensure an obscure documented EFILive code still receives
    useful classification instead of being treated as completely unknown.
    ------------------------------------------------------------
  */

  var F = [
    {
      pattern: /^\$00(?:0[1-9A-F]|1[0-9A-F])$/,
      title: 'EFILive USB driver error',
      category: 'usb_driver',
      customerText:
        'This error belongs to EFILive’s USB driver error group. Check the device/USB connection. If the exact corrective action above does not resolve it, use EFILive Support.',
      action: 'vendor_support_if_persistent',
      link: EFI_SUPPORT,
      linkLabel: 'EFILive Support'
    },

    {
      pattern: /^\$00[2-7][0-9A-F]$/,
      title: 'EFILive HAPI/software communication error',
      category: 'pc_software',
      customerText:
        'This error belongs to EFILive’s HAPI/software communication group. Verify the current EFILive V8 installation and device connection.',
      action: 'check_v8_then_vendor_support',
      link: EFI_SUPPORT,
      linkLabel: 'EFILive Support'
    },

    {
      pattern: /^\$00[89AB][0-9A-F]$/,
      title: 'EFILive device boot/firmware error',
      category: 'device_firmware',
      customerText:
        'This error belongs to EFILive’s device boot/firmware group. Verify current device firmware. Persistent boot or firmware errors should be handled by EFILive Support.',
      action: 'vendor_support_if_persistent',
      link: EFI_SUPPORT,
      linkLabel: 'EFILive Support'
    },

    {
      pattern: /^\$00C[0-9A-F]$/,
      title: 'EFILive internal flash-memory error',
      category: 'device_hardware',
      customerText:
        'This error belongs to EFILive’s internal flash-memory group. Contact EFILive if the error persists.',
      action: 'vendor_support',
      link: EFI_SUPPORT,
      linkLabel: 'EFILive Support',
      vendorSupport: true
    },

    {
      pattern: /^\$00[DEF][0-9A-F]$/,
      title: 'EFILive operating-system/internal error',
      category: 'device_internal',
      customerText:
        'This error belongs to EFILive’s internal operating-system group. Contact EFILive if it persists.',
      action: 'vendor_support',
      link: EFI_SUPPORT,
      linkLabel: 'EFILive Support'
    },

    {
      pattern: /^\$01[0-7][0-9A-F]$/,
      title: 'EFILive USB communication error',
      category: 'usb_connection',
      customerText:
        'This error belongs to EFILive’s USB communication group. Check the USB cable, port and device connection before retrying.',
      action: 'check_usb'
    },

    {
      pattern: /^\$01[89A-F][0-9A-F]$/,
      title: 'EFILive device file-system error',
      category: 'device_storage',
      customerText:
        'This error belongs to EFILive’s device storage/file-system group. Check device storage, configuration and required files.',
      action: 'check_storage'
    },

    {
      pattern: /^\$02[0-7][0-9A-F]$/,
      title: 'EFILive file-transfer error',
      category: 'file_transfer',
      customerText:
        'EFILive encountered a file-transfer problem. If re-copying the required file does not resolve it, contact EFILive Support.',
      action: 'vendor_support_if_persistent',
      link: EFI_SUPPORT,
      linkLabel: 'EFILive Support'
    },

    {
      pattern: /^\$02[89A-F][0-9A-F]$/,
      title: 'EFILive vehicle communication error',
      category: 'vehicle_communication',
      customerText:
        'This error belongs to EFILive’s OBD/vehicle-communication group. Confirm ignition is ON, check OBD power/connections and verify vehicle communication.',
      action: 'check_vehicle_power_communication'
    },

    {
      pattern: /^\$03[0-9A-F]{2}$/,
      title: 'Controller communication/programming error',
      category: 'controller',
      customerText:
        'The controller returned an error during communication or programming. Record the exact code and create a support ticket if basic communication checks do not resolve it.',
      action: 'ticket_if_persistent',
      ticketRecommendedIfPersistent: true
    },

    {
      pattern: /^\$04[0-7][0-9A-F]$/,
      title: 'EFILive SD-card error',
      category: 'device_storage',
      customerText:
        'This error belongs to EFILive’s SD-card group. Check the card installation, available storage and card condition.',
      action: 'check_sd_card'
    },

    {
      pattern: /^\$04[89A-F][0-9A-F]$/,
      title: 'EFILive Black Box operation error',
      category: 'bbx_configuration',
      customerText:
        'This error belongs to EFILive’s Black Box Logging/Flashing group. Verify software/firmware and program the correct BBX configuration.',
      action: 'reprogram_bbx',
      bbxRelated: true,
      link: SFG_HELP,
      linkLabel: 'EFI Live Instructions'
    },

    {
      pattern: /^\$0[56][0-9A-F]{2}$/,
      title: 'EFILive read/flash error',
      category: 'read_flash',
      customerText:
        'This error occurred in EFILive’s reading/flashing system. Record the exact code. If a write has failed or the controller no longer communicates normally, stop and create an SFG support ticket.',
      action: 'ticket',
      ticketRecommended: true
    },

    {
      pattern: /^\$07[0-9A-F]{2}$/,
      title: 'EFILive scanning/logging error',
      category: 'logging_configuration',
      customerText:
        'This error belongs to EFILive’s scanning system. Verify the selected controller and logging configuration.',
      action: 'check_logging_configuration'
    },

    {
      pattern: /^\$0[89][0-9A-F]{2}$/,
      title: 'EFILive tune-script error',
      category: 'tune_script',
      customerText:
        'This error belongs to EFILive’s tune-script system. Create an SFG ticket if the error occurred while using an SFG-supplied file or process.',
      action: 'ticket_if_sfg_file',
      ticketRecommendedIfPersistent: true
    },

    {
      pattern: /^\$0A[0-7][0-9A-F]$/,
      title: 'EFILive BBX configuration error',
      category: 'bbx_configuration',
      customerText:
        'This error belongs to EFILive’s BBX configuration group. Review and reprogram the AutoCal/FlashScan BBX configuration.',
      action: 'reprogram_bbx',
      bbxRelated: true,
      link: SFG_HELP,
      linkLabel: 'EFI Live Instructions'
    },

    {
      pattern: /^\$0A[89A-F][0-9A-F]$/,
      title: 'EFILive internal error',
      category: 'device_internal',
      customerText:
        'This is an EFILive internal error. Contact EFILive Support if it persists.',
      action: 'vendor_support',
      link: EFI_SUPPORT,
      linkLabel: 'EFILive Support',
      vendorSupport: true
    },

    {
      pattern: /^\$0B[0-7][0-9A-F]$/,
      title: 'EFILive cryptographic/security error',
      category: 'device_security',
      customerText:
        'This error belongs to EFILive’s cryptographic/security system. Contact EFILive Support if it persists.',
      action: 'vendor_support',
      link: EFI_SUPPORT,
      linkLabel: 'EFILive Support',
      vendorSupport: true
    }
  ];

  window.SFGEFILiveErrorData = {
    version: '1.0.0',
    source: GUIDE,
    exact: X,
    families: F
  };
})();